import React, { useState, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function EditOptions({ isOpen, onClose, onEdit, onDelete, onArchive, isCampaign }) {
  const { browseState } = useContext(BrowseContext)
  const [hoverEdit, setHoverEdit] = useState(false)
  const [hoverCopy, setHoverCopy] = useState(false)
  const [hoverUpdateFolder, setHoverUpdateFolder] = useState(false)
  const [hoverArchive, setHoverArchive] = useState(false)
  const [hoverDelete, setHoverDelete] = useState(false)

  return (
    isOpen && (
      <section
        className='flex flex-col gap-1 shadow z-30 absolute top-7 -right-5 bg-white dark:bg-rb-dark-mode w-[150px] mt-2 border-1 dark:border-rb-dark-mode-lighter rounded-md'
      >
        {
          !isCampaign && (
            <button
              className={`w-full ${hoverEdit ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''} flex items-center p-2 dark:text-white`}
              onMouseEnter={() => setHoverEdit(true)}
              onMouseLeave={() => setHoverEdit(false)}
              onClick={(e) => {
                e.stopPropagation()
                onEdit()
                onClose()
              }}
            >
              <span>Edit details</span>
            </button>
          )
        }
        <button
          className={`w-full ${hoverCopy ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''} flex items-center p-2 dark:text-white`}
          onMouseEnter={() => setHoverCopy(true)}
          onMouseLeave={() => setHoverCopy(false)}
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
        >
          <span>Copy link</span>
        </button>
        {isCampaign && (
          <button
            className={`w-full ${hoverUpdateFolder ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''} flex items-center p-2 dark:text-white`}
            onMouseEnter={() => setHoverUpdateFolder(true)}
            onMouseLeave={() => setHoverUpdateFolder(false)}
            onClick={(e) => {
              e.stopPropagation()
              browseState.toggleUpdateCampaignFolder()
              onClose()
            }}
          >
            <span>Update folder</span>
          </button>
        )}
        {onArchive && (
          <button
            className={`w-full ${hoverArchive ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''} flex items-center p-2 dark:text-white`}
            onMouseEnter={() => setHoverArchive(true)}
            onMouseLeave={() => setHoverArchive(false)}
            onClick={(e) => {
              e.stopPropagation()
              onArchive()
              onClose()
            }}
          >
            <span>Archive</span>
          </button>
        )}
        <button
          className={`w-full ${hoverDelete ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''} flex items-center p-2 dark:text-white`}
          onMouseEnter={() => setHoverDelete(true)}
          onMouseLeave={() => setHoverDelete(false)}
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
            onClose()
          }}
        >
          <span>Delete</span>
        </button>
      </section>
    )
  )
})
